import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { fetchStates, deleteState } from '../../utils/api';
import MasterDataTable from '../../components/MasterDataTable';

const columns = [
  { id: 'stateId', label: 'ID', minWidth: 50 },
  { id: 'stateName', label: 'State Name', minWidth: 170 },
];

const StateList = ({ onEdit, searchQuery = '' }) => {
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const loadStates = async () => {
      setLoading(true);
      try {
        const response = await fetchStates();
        if (cancelled) return;
        setStates(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching states:', err);
        if (!cancelled) {
          setError('Failed to load states. Please try again later.');
          setStates([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadStates();
    return () => {
      cancelled = true;
    };
  }, [refreshTrigger]);

  const handleDelete = async (state) => {
    try {
      await deleteState(state.stateId, {
        previousData: state,
        identifier: state.stateName
      });
      setRefreshTrigger(prev => prev + 1);
    } catch (err) {
      console.error('Error deleting state:', err);
      alert('Failed to delete state. It may be referenced by other records.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        States
      </Typography>
      
      <MasterDataTable
        persistKey="state"
        data={states}
        columns={columns}
        isLoading={loading}
        searchQuery={searchQuery}
        onEdit={onEdit}
        onDelete={handleDelete}
        emptyMessage="No states found. Add your first state!"
      />
      
      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default StateList; 